import React from "react";
import intl from "react-intl-universal";
import styled from "styled-components";

import { Layout } from "../containers/Layout";
import { ContentBody } from "../containers/ContentBody";
import { ContentHeader } from "../containers/ContentHeader";
import { PasswordSettings } from "./settings/PasswordSettings";
import { ValidationProvider } from "../contexts/ValidationContext";

const SettingsStyle = styled.div`
    margin: 0 auto;
    max-width: 1000px;
    min-width: 700px;
    background-color: ${props => props.theme.white};
    border: 1px solid ${props => props.theme.greyLight};
`;

export const Settings = () =>
    <Layout>
        <ContentHeader title={intl.get("navigation.settings")} />
        <ContentBody>
            <SettingsStyle>
                <ValidationProvider>
                    <PasswordSettings />
                </ValidationProvider>
            </SettingsStyle>
        </ContentBody>
    </Layout>;
